<template>
    <FormInput :context="context">
        <PrimeVueInputNumber
            v-model="value"
            v-bind="attributes"
            v-on="$listeners"
            @blur="context.blurHandler"
            ref="input"
        />
    </FormInput>
</template>

<script>
import FormInputMixin from "@/components/forms/inputs/mixins/FormInputMixin";
import PrimeVueInputNumber from "primevue/inputnumber";

export default {
    components: { PrimeVueInputNumber },
    mixins: [FormInputMixin],
    props: {
        locale: {
            // BCP 47 language tag
            type: String,
            default: "en-US",
        },
        // not supported by primevue
        // roundingMode: {
        //     type: String,
        //     default: "halfExpand",
        // },
        // roundingPriority: {
        //     type: String,
        //     default: "auto",
        // },
        // roundingIncrement: {
        //     type: Number,
        //     default: 1,
        // },
        currency: {
            // ISO 4217 currency code
            type: String,
        },
        // options for https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat
        currencySign: {
            type: String,
        },
        // currencyDisplay: {
        //     type: String,
        //     default: 'symbol'
        // },
        minFractionDigits: {
            type: Number,
        },
        maxFractionDigits: {
            type: Number,
        },
        minSignificantDigits: {
            type: Number,
        },
        maxSignificantDigits: {
            type: Number,
        },
    },
    watch: {
        currency() {
            this.value = this.parseValue(this.context.model);
        },
    },
    computed: {
        defaults() {
            const defaults = {
                mode: "decimal",
                locale: this.locale,
                minFractionDigits: this.minFractionDigits,
                maxFractionDigits: this.maximumFractionDigits,
                minSignificantDigits: this.minSignificantDigits,
                maxSignificantDigits: this.maxSignificantDigits,
                // not supported by primevue but is supported by number format
                // roundingMode: this.roundingMode,
                // roundingPriority: this.roundingPriority,
                // roundingIncrement: this.roundingIncrement,
            };

            if (this.currency && this.currency !== "") {
                Object.assign(defaults, {
                    mode: "currency",
                    currency: this.currency,
                    currencyDisplay: this.currencyDisplay,
                    // currencySign: this.currencySign,
                });
            }

            return defaults;
        },
        valueAsString() {
            return `${this.value || ""}`;
        },
    },
    methods: {
        onValueChanged() {
            this.context.model = this.valueAsString || "";
        },
        parseValue(value = "") {
            if (this.$refs.input) {
                return this.$refs.input.parseValue(`${value || ""}`);
            }

            return +value;
        },
    },
};
</script>
